"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomMenuTypeEnum = void 0;
var CustomMenuTypeEnum;
(function (CustomMenuTypeEnum) {
  /** элемент типа Classroom */
  CustomMenuTypeEnum[CustomMenuTypeEnum["classroom"] = 1] = "classroom";
  /** элемент типа School */
  CustomMenuTypeEnum[CustomMenuTypeEnum["school"] = 2] = "school";
  /** элемент типа Collection */
  CustomMenuTypeEnum[CustomMenuTypeEnum["collection"] = 3] = "collection";
  /** элемент типа User */
  CustomMenuTypeEnum[CustomMenuTypeEnum["user"] = 4] = "user";
})(CustomMenuTypeEnum = exports.CustomMenuTypeEnum || (exports.CustomMenuTypeEnum = {}));
